require("!!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/node_modules/script-loader/addScript.js")(require("!!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/node_modules/raw-loader/index.js!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/www/lib/angular-translate-loader-static-files/angular-translate-loader-static-files.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./www/lib/angular-translate-loader-static-files/angular-translate-loader-static-files.js
// module id = 479
// module chunks = 0